
import { Component, Mixins } from "vue-property-decorator";
import { IDrawableItemEditable } from "../IDrawableItemEditable";
import { ModelEditableMixin } from "../../../system/mixins";
import { IDrawableItem } from "../../../../domain/document/items";

@Component({
})
export default class DrawableItemEditorMixin extends Mixins(ModelEditableMixin) implements IDrawableItemEditable {
  editingSource: IDrawableItem;

  get isEditable(): boolean {
    return this.editingSource && this.editingSource.isEditable;
  }
}
